export const NEW = 'NEW';
export const CURRENT = 'CURRENT';
export const ACTIVITY_MODAL = 'ACTIVITY_MODAL';
export const DASHBOARD = 'DASHBOARD';
export const CANONICAL = 'CANONICAL';
export const EDITING = 'EDITING';
